<template>
  <div>
    <font-awesome-icon
      :icon="'caret-down'"
      class="fa" />
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'

library.add(faCaretDown)

export default {
  name: 'CoozzyCaretDownIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-grey-dark;
  }
</style>
